// extracted by mini-css-extract-plugin
export default {"container":"AnnouncementCtaButton_container__Husv5","button":"AnnouncementCtaButton_button__v5LU8","label":"AnnouncementCtaButton_label__7akzs"};